import styled from 'styled-components';

export const InstitutionalStyle = styled.section`
  padding: 150px 15% 0;

  h4, p {
    font-family: 'Poppins', sans-serif!important;
  }

  h4 {
    font-size: 19px;
    text-align: center;
    margin-bottom: 20px;
  }

  p {
    text-align: left!important;
    margin-bottom: 30px!important;
  }
`;